// src/components/ui/Modal.jsx
import React from "react";

// Kopf und Fuss bleiben stehen, nur der Inhalt scrollt. So sind Schliessen und
// die Speichern-Knoepfe auch bei hohem Inhalt (z. B. Stoppuhr) immer erreichbar.
// `dvh` statt `vh`: auf dem Handy zaehlt die sichtbare Hoehe ohne Adressleiste.
export default function Modal({ open, onClose, title, children, footer, className = "" }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className={`bg-secondary-900 text-white rounded-lg shadow-xl w-full max-w-lg ${className} max-h-[90vh] max-h-[90dvh] flex flex-col relative`}>
        {/* Header */}
        <div className="flex justify-between items-center px-6 pt-6 pb-4 flex-none">
          <h2 className="text-xl font-bold">{title}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white">✕</button>
        </div>

        {/* Body */}
        <div className="space-y-4 px-6 flex-1 min-h-0 overflow-y-auto">{children}</div>

        {/* Footer */}
        {footer && (
          <div className="flex justify-end gap-2 px-6 pt-4 pb-6 flex-none border-t border-secondary-700">
            {footer}
          </div>
        )}
        {!footer && <div className="pb-6 flex-none" />}
      </div>
    </div>
  );
}
